import {
  INVOICE_SUB_AGENT_INTERNAL_CREATE_FAIL,
  INVOICE_SUB_AGENT_INTERNAL_CREATE_REQUEST,
  INVOICE_SUB_AGENT_INTERNAL_CREATE_SUCCESS,
  INVOICE_SUB_AGENT_INTERNAL_DELETE_FAIL,
  INVOICE_SUB_AGENT_INTERNAL_DELETE_REQUEST,
  INVOICE_SUB_AGENT_INTERNAL_DELETE_SUCCESS,
  INVOICE_SUB_AGENT_INTERNAL_GET_FAIL,
  INVOICE_SUB_AGENT_INTERNAL_GET_REQUEST,
  INVOICE_SUB_AGENT_INTERNAL_GET_SUCCESS,
  INVOICE_SUB_AGENT_INTERNAL_LIST_FAIL,
  INVOICE_SUB_AGENT_INTERNAL_LIST_REQUEST,
  INVOICE_SUB_AGENT_INTERNAL_LIST_SUCCESS,
  INVOICE_SUB_AGENT_INTERNAL_UPDATE_FAIL,
  INVOICE_SUB_AGENT_INTERNAL_UPDATE_REQUEST,
  INVOICE_SUB_AGENT_INTERNAL_UPDATE_SUCCESS,
} from "../constants/invoiceSubAgentInternalConstants";
import api from "../core/api";

export const listSubAgentInternalInvoices = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: INVOICE_SUB_AGENT_INTERNAL_LIST_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await api.get(
      "/accounts/subagentinternalinvoice",
      config
    );

    var dt = data.Result;

    if (typeof dt === "string") {
      dispatch({
        type: INVOICE_SUB_AGENT_INTERNAL_LIST_FAIL,
        payload: data.Result.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: INVOICE_SUB_AGENT_INTERNAL_LIST_SUCCESS,
        payload: dt,
      });
    }
  } catch (error) {
    dispatch({
      type: INVOICE_SUB_AGENT_INTERNAL_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const createSubAgentInternalInvoices =
  (subagentInvoiceJson) => async (dispatch, getState) => {
    try {
      dispatch({
        type: INVOICE_SUB_AGENT_INTERNAL_CREATE_REQUEST,
      });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await api.post(
        "/accounts/subagentinternalinvoice",
        subagentInvoiceJson,
        config
      );

      var dt = data.Result;

      if (dt.includes("error")) {
        dispatch({
          type: INVOICE_SUB_AGENT_INTERNAL_CREATE_FAIL,
          payload: data.Result.replace("Error - ", ""),
        });
      } else {
        dispatch({
          type: INVOICE_SUB_AGENT_INTERNAL_CREATE_SUCCESS,
          payload: dt,
        });
      }
    } catch (error) {
      dispatch({
        type: INVOICE_SUB_AGENT_INTERNAL_CREATE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };


  export const getSubAgentInternalInvoices =
  (invoiceId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: INVOICE_SUB_AGENT_INTERNAL_GET_REQUEST,
      });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await api.get(
        "/accounts/subagentinternalinvoice/" + invoiceId,
        config
      );

      var dt = data.Result;

      if (typeof dt === "string") {
        dispatch({
          type: INVOICE_SUB_AGENT_INTERNAL_GET_FAIL,
          payload: data.Result.replace("Error - ", ""),
        });
      } else {
        dispatch({
          type: INVOICE_SUB_AGENT_INTERNAL_GET_SUCCESS,
          payload: dt,
        });
      }
    } catch (error) {
      dispatch({
        type: INVOICE_SUB_AGENT_INTERNAL_GET_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const updateSubAgentInternalInvoice =
  (invoiceId, subagentinvoicejson) => async (dispatch, getState) => {
    try {
      dispatch({
        type: INVOICE_SUB_AGENT_INTERNAL_UPDATE_REQUEST,
      });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await api.put(
        "/accounts/subagentinternalinvoice/" + invoiceId,
        subagentinvoicejson,
        config
      );

      var dt = data.Result;

      if (dt.includes("Error")) {
        dispatch({
          type: INVOICE_SUB_AGENT_INTERNAL_UPDATE_FAIL,
          payload: data.Result.replace("Error - ", ""),
        });
      } else {
        dispatch({
          type: INVOICE_SUB_AGENT_INTERNAL_UPDATE_SUCCESS,
          payload: dt,
        });
      }
    } catch (error) {
      dispatch({
        type: INVOICE_SUB_AGENT_INTERNAL_UPDATE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };


export const deleteSubAgentInternalInvoice =
  (invoiceId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: INVOICE_SUB_AGENT_INTERNAL_DELETE_REQUEST,
      });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await api.delete(
        "/accounts/subagentinternalinvoice/" + invoiceId,
        config
      );

      var dt = data.Result;

      if (dt.includes("Error")) {
        dispatch({
          type: INVOICE_SUB_AGENT_INTERNAL_DELETE_FAIL,
          payload: data.Result.replace("Error - ", ""),
        });
      } else {
        dispatch({
          type: INVOICE_SUB_AGENT_INTERNAL_DELETE_SUCCESS,
          payload: dt,
        });
      }
    } catch (error) {
      dispatch({
        type: INVOICE_SUB_AGENT_INTERNAL_DELETE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

  